<div class="page-list create-page">
    <div class="page-list-wrapper">
        <div class="mantis-theme row d-flex w-100">
            <div class="col-sm-12">
                <div class="card">
                    <div class="chat-wrapper">
                        <div class="offcanvas-lg offcanvas-start chat-offcanvas" tabindex="-1" id="offcanvas_broadcast_audiences">
                            <div class="offcanvas-body p-0">
                                <div id="broadcast_audience_list" class="show collapse collapse-horizontal">
                                    <div class="chat-user_list">
                                        <div class="card-body px-4">
                                            <div class="mb-3">
                                                <h5 class="mb-1 fw-bold">Audiences</h5>
                                                <p class="audiences-description">
                                                    System audiences are created automatically. Custom audiences are based on user tags.
                                                </p>
                                            </div>

                                            <div class="d-flex align-items-center gap-2 mb-3">
                                                <div class="form-search position-relative flex-grow-1">
                                                    <span class="search-icon">
                                                        <img src="assets/common/ic_search.svg" alt="Search">
                                                    </span>
                                                    <input type="search"
                                                           class="form-control"
                                                           placeholder="Search audiences..."
                                                           [(ngModel)]="audienceSearch" />
                                                    <button type="button"
                                                            class="clear-search"
                                                            *ngIf="audienceSearch"
                                                            (click)="clearAudienceSearch()">
                                                        <img src="assets/common/ic_x.svg" alt="Clear search">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="chat-thread-list-container">
                                            <div class="card-body py-0 px-0">
                                                @if (audiencesLoading) {
                                                    <div class="px-4 py-3 text-muted small">Loading audiences…</div>
                                                } @else {
                                                    @if (filteredSystem.length > 0) {
                                                        <div class="custom-group-chats-label system-audiences-label">
                                                            <h6 class="mb-0">System audiences</h6>
                                                        </div>
                                                        <div class="list-group list-group-flush">
                                                            @for (audience of filteredSystem; track audience.audience_key) {
                                                                <a href="javascript:"
                                                                   class="list-group-item list-group-item-action user-list py-2"
                                                                   (click)="selectAudience(audience)"
                                                                   [ngClass]="{ 'bg-light-primary': selectedAudience?.audience_key === audience.audience_key }">
                                                                    <div class="media align-items-center">
                                                                        <div class="chat-avatar position-relative">
                                                                            <ng-container *ngTemplateOutlet="audienceAvatar; context: { audience: audience }"></ng-container>
                                                                        </div>
                                                                        <div class="media-body">
                                                                            <div class="d-flex align-items-center justify-content-between mb-1">
                                                                                <h5 class="mb-0 text-truncate fw-bold">{{ audience.name }}</h5>
                                                                            </div>
                                                                            <div class="mb-1">
                                                                                <span class="text-sm text-muted">
                                                                                    {{ audience.member_count || 0 }}
                                                                                    {{ audience.member_count === 1 ? 'user' : 'users' }}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            }
                                                        </div>
                                                    }

                                                    <div class="custom-group-chats-label d-flex align-items-center justify-content-between">
                                                        <h6 class="mb-0">Custom audiences</h6>
                                                    </div>

                                                    <div class="list-group list-group-flush">
                                                        @if (filteredCustom.length > 0) {
                                                            @for (audience of filteredCustom; track audience.audience_key) {
                                                                <a href="javascript:"
                                                                   class="list-group-item list-group-item-action user-list py-2"
                                                                   (click)="selectAudience(audience)"
                                                                   [ngClass]="{ 'bg-light-primary': selectedAudience?.audience_key === audience.audience_key }">
                                                                    <div class="media align-items-center">
                                                                        <div class="chat-avatar position-relative">
                                                                            <ng-container *ngTemplateOutlet="audienceAvatar; context: { audience: audience }"></ng-container>
                                                                        </div>
                                                                        <div class="media-body">
                                                                            <div class="d-flex align-items-center justify-content-between mb-1">
                                                                                <h5 class="mb-0 text-truncate fw-bold">{{ audience.name }}</h5>
                                                                            </div>
                                                                            <div class="mb-1">
                                                                                <span class="text-sm text-muted">
                                                                                    {{ audience.member_count || 0 }}
                                                                                    {{ audience.member_count === 1 ? 'user' : 'users' }}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            }
                                                        } @else if (!audiencesLoading && !filteredSystem.length && !filteredCustom.length) {
                                                            <div class="text-center no-conversations py-4 px-3">
                                                                <img src="assets/messaging/ic_no_conversations.svg" alt="">
                                                                <h6 class="mt-2">No audiences found</h6>
                                                                <span>Try a different search term.</span>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="chat-content broadcast-chat-content">
                            @if (selectedAudience) {
                                <div class="broadcast-thread-header border-bottom px-4 py-3 d-flex align-items-center gap-3">
                                    <div class="chat-avatar flex-shrink-0">
                                        <ng-container *ngTemplateOutlet="audienceAvatar; context: { audience: selectedAudience }"></ng-container>
                                    </div>
                                    <div class="min-w-0 flex-grow-1">
                                        <h5 class="mb-1 fw-bold text-truncate">Broadcast to: {{ selectedAudience.name }}</h5>

                                        <p class="broadcast-thread-header-description">
                                        @if (hasSelectedAudienceMembers) {
                                            This broadcast will be sent as an individual inbox message to {{ selectedAudience.member_count }}
                                            {{ selectedAudience.member_count === 1 ? 'user' : 'users' }}.
                                        } @else {
                                            Broadcasts cannot be sent because this audience has no members.
                                        }
                                        </p> 
                                        
                                    </div>
                                </div>

                                <div class="broadcast-messages-scroll flex-grow-1">
                                    @if (messagesLoading && messages.length === 0) {
                                        <div class="broadcast-messages-loading text-muted small">Loading broadcasts…</div>
                                    } @else if (!messagesLoading && messages.length === 0) {
                                        <div class="broadcast-empty-state text-center">
                                            <img src="assets/messaging/ic_no_messages.svg" alt="">
                                            @if (hasSelectedAudienceMembers) {
                                                <h6 class="mb-2">No broadcasts yet</h6>
                                                <p class="text-muted mb-0">
                                                    No broadcasts have been sent to this audience yet. Sent broadcasts will appear here.
                                                </p>
                                            } @else {
                                                <h6 class="mb-2">No members added yet</h6>
                                                <p class="text-muted mb-0">
                                                    This audience has no members. Add users to send a broadcast to this audience.
                                                </p>
                                            }
                                        </div>
                                    } @else {
                                        <div class="broadcast-messages-list-scroll">
                                            <div class="broadcast-message-list px-4 py-3">
                                                @for (msg of messages; track msg.id) {
                                                    <div class="broadcast-message-card">
                                                        <div class="d-flex align-items-start justify-content-between gap-2 mb-2">
                                                            <div class="fw-semibold small text-truncate">
                                                                {{ msg.sender?.name || 'You' }}
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2 flex-shrink-0">
                                                                @if (hasSelectedAudienceMembers) {
                                                                    <!--
                                                                    <button type="button"
                                                                            class="btn btn-link btn-sm py-0 px-1 broadcast-message-edit"
                                                                            [disabled]="!canEditBroadcastMessage(msg)"
                                                                            (click)="startEditBroadcastMessage(msg)"
                                                                            [attr.title]="canEditBroadcastMessage(msg) ? 'Edit broadcast' : 'Sent broadcasts cannot be edited'">
                                                                        <img src="assets/common/ic_edit.svg" alt="Edit" width="16" height="16">
                                                                    </button>
                                                                    -->
                                                                }
                                                                <span class="text-muted text-nowrap small">
                                                                    {{ msg.sent_at || msg.created_at | dateFormat:'MMM d, y, h:mm a' }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        @if (msg.message?.trim()) {
                                                            <p class="mb-2 broadcast-message-text">{{ msg.message }}</p>
                                                        }
                                                        @if (hasAttachments(msg)) {
                                                            <div class="broadcast-message-attachments">
                                                                @for (attachment of msg.attachments; track attachment.broadcast_attachment_id) {
                                                                    @if (isImageAttachment(attachment)) {
                                                                        <div class="broadcast-attachment-thumb">
                                                                            <img [src]="attachment.attachment.url"
                                                                                 [alt]="attachment.attachment.name || 'Image'"
                                                                                 class="broadcast-attachment-image"
                                                                                 [class.broadcast-attachment-image--clickable]="!isGifAttachment(attachment)"
                                                                                 loading="lazy"
                                                                                 (click)="!isGifAttachment(attachment) && openAttachmentPreview(attachment)">
                                                                        </div>
                                                                    } @else if (isVideoAttachment(attachment)) {
                                                                        <div class="broadcast-attachment-thumb broadcast-attachment-thumb--video"
                                                                             (click)="openAttachmentPreview(attachment)">
                                                                            <img [src]="attachment.attachment.thumbnail || attachment.attachment.url"
                                                                                 [alt]="attachment.attachment.name || 'Video'"
                                                                                 class="broadcast-attachment-image"
                                                                                 loading="lazy">
                                                                            <div class="broadcast-attachment-play">
                                                                                <img src="assets/common/ic_play_circle.svg" alt="">
                                                                            </div>
                                                                        </div>
                                                                    } @else {
                                                                        <a class="broadcast-attachment-doc"
                                                                           [href]="attachment.attachment.url"
                                                                           target="_blank"
                                                                           rel="noopener noreferrer"
                                                                           [title]="attachment.attachment.name">
                                                                            <i [class]="getAttachmentIcon(attachment)"></i>
                                                                            <span class="broadcast-attachment-doc-name">{{ attachment.attachment.name }}</span>
                                                                        </a>
                                                                    }
                                                                }
                                                            </div>
                                                        }
                                                        <div class="d-flex flex-wrap align-items-center gap-2">
                                                            @if (msg.status_badge?.label) {
                                                                <span class="badge rounded-pill broadcast-status-badge"
                                                                      [ngClass]="'broadcast-status-' + (msg.status_badge.key || 'default')"
                                                                      [ngStyle]="statusBadgeNgStyle(msg.status_badge)">
                                                                    {{ msg.status_badge.label }}
                                                                </span>
                                                            }
                                                            @if (msg.recipients_count > 0) {
                                                                <span class="text-muted small">
                                                                    {{ msg.recipients_count }} recipient{{ msg.recipients_count === 1 ? '' : 's' }}
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            @if (hasMoreMessages) {
                                                <div class="text-center pb-3">
                                                    <button type="button"
                                                            class="btn btn-sm btn-outline-primary"
                                                            [disabled]="messagesLoading"
                                                            (click)="loadMoreMessages()">
                                                        {{ messagesLoading ? 'Loading…' : 'Load more' }}
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>

                                @if (hasSelectedAudienceMembers) {
                                    <div class="broadcast-messages-composer">
                                        <app-messages-tab
                                            context="broadcast"
                                            [broadcastAudience]="selectedAudience"
                                            [broadcastEditingMessage]="editingBroadcastMessage"
                                            broadcastMessagePlaceholder="Write your broadcast message…"
                                            (broadcastMessageUpserted)="onBroadcastMessageUpserted($event)"
                                            (broadcastMessageRemoved)="onBroadcastMessageRemoved($event)"
                                            (broadcastEditCancelled)="onBroadcastEditCancelled()">
                                        </app-messages-tab>
                                    </div>
                                } @else {
                                    <div class="broadcast-composer-disabled border-top px-4 py-3">
                                        <p class="text-muted small mb-0">
                                            The message composer will appear here once members are added to this audience.
                                        </p>
                                    </div>
                                }
                            } @else {
                                <div class="no-messages text-center broadcast-no-audience-selected py-5">
                                    <img src="assets/messaging/ic_no_messages.svg" alt="">
                                    <h6 class="mb-2">No audience selected</h6>
                                    <p class="text-muted mb-0">
                                        Select an audience from the list on the left.
                                    </p>
                                </div>
                            }
                        </div>

                        @if (selectedAudience) {
                            <aside class="chat-user_info broadcast-audience-sidebar">
                                <div class="broadcast-sidebar-inner">
                                    <div class="card profile-card">
                                        <div class="card-body mb-0">
                                            <div class="profile-info">
                                                <div class="profile-avatar">
                                                    <ng-container *ngTemplateOutlet="audienceAvatar; context: { audience: selectedAudience }"></ng-container>
                                                </div>
                                                <h4 class="profile-name">{{ selectedAudience.name }}</h4>
                                                <div class="profile-members-count">
                                                    {{ selectedAudience.member_count || 0 }}
                                                    {{ (selectedAudience.member_count || 0) === 1 ? 'member' : 'members' }}
                                                </div>
                                                <div class="profile-type-badge mt-2"
                                                     [class.system]="selectedAudience.type === 'system'"
                                                     [class.custom]="selectedAudience.type === 'custom'">
                                                    {{ selectedAudience.type === 'system' ? 'System audience' : 'Custom audience' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card details-card">
                                        <div class="card-header d-flex justify-content-between align-items-center">
                                            <h5 class="mb-0 fw-bold">Audience details</h5>
                                        </div>
                                        
                                        <div class="card-body">
                                            <div class="detail-item">
                                                <label class="detail-label">Audience type</label>
                                                <div class="detail-value text-capitalize">{{ selectedAudience.type }}</div>
                                            </div>
                                            <div class="detail-item">
                                                <label class="detail-label">Total members</label>
                                                <div class="detail-value">{{ selectedAudience.member_count || 0 }}</div>
                                            </div>
                                            <div class="detail-item">
                                                <label class="detail-label">Description</label>
                                                <div class="detail-value chat-room-description">
                                                    {{ selectedAudience.description || '—' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card members-card">
                                        <div class="card-header d-flex justify-content-between align-items-center">
                                            <h5 class="mb-0 fw-bold">Members</h5>
                                            @if (membersHasMorePages) {
                                                <a href="#" class="see-all-link" (click)="onSeeAllMembers($event)">See all</a>
                                            }
                                        </div>
                                        <div class="card-body">
                                            @if (selectedAudience.member_count > audienceMembers.length) {
                                                <div class="member-search mt-2">
                                                    <img src="assets/common/ic_search_s_size.svg" alt="Search">
                                                    <input type="text"
                                                           class="form-control"
                                                           placeholder="Search members"
                                                           [(ngModel)]="memberSearchQuery"
                                                           (ngModelChange)="onMemberSearchChange()">
                                                </div>
                                            }

                                            <div class="users-list p-0">
                                                @if (membersLoading) {
                                                    <div class="users-list-loading">
                                                        {{ memberSearchQuery.trim() ? 'Searching...' : 'Loading members...' }}
                                                    </div>
                                                } @else {
                                                    @for (member of audienceMembers; track member.id) {
                                                        <div class="user-item">
                                                            <div class="user-avatar">
                                                                @if (member.avatar) {
                                                                    <img [src]="member.avatar" [alt]="member.name" class="avatar-image">
                                                                } @else {
                                                                    <div class="avatar-circle">
                                                                        <span class="avatar-initials">{{ getMemberInitials(member) }}</span>
                                                                    </div>
                                                                }
                                                            </div>

                                                            <div class="user-info">
                                                                <div class="user-name">{{ member.name }}</div>
                                                                <div class="user-email">{{ member.email }}</div>
                                                            </div>

                                                            <div class="user-actions" (click)="$event.stopPropagation()">
                                                                <button class="btn-icon action" type="button" title="More options" (click)="onToggleMemberMenu($event, member)">
                                                                    <img src="assets/common/ic_three_dots.svg" alt="More options">
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }

                                                    @if (audienceMembers.length === 0) {
                                                        <div class="users-list-empty">No members found</div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    @if (openMemberMenuId !== null && submenuPosition && getOpenMember(); as member) {
                                        <div class="action-submenu action-submenu-fixed"
                                             [style.top.px]="submenuPosition.top"
                                             [style.left.px]="submenuPosition.left"
                                             (click)="$event.stopPropagation()">
                                            <button type="button" class="action-submenu-item" (click)="onOpenMemberProfile(member)">
                                                <img src="assets/common/ic_new_tab.svg" alt="">
                                                <span>Open client profile</span>
                                            </button>
                                            <button type="button" class="action-submenu-item" (click)="onMessageMember(member)">
                                                <img src="assets/messaging/ic_new_message.svg" alt="">
                                                <span>Message client</span>
                                            </button>
                                        </div>
                                    }

                                </div>
                            </aside>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #audienceAvatar let-audience="audience">
    <div class="group-chat-icon group-chat-icon-wrapper"
         [class.group-chat-icon-wrapper--custom]="audience.type === 'custom'">
        <img class="avatar-image"
             [src]="getAudienceIconUrl(audience)"
             alt="">
    </div>
</ng-template>

@if (showManageMembersModal && selectedAudience) {
    <app-manage-broadcast-members-modal
        [audienceKey]="selectedAudience.audience_key"
        [memberCount]="selectedAudience.member_count ?? 0"
        (close)="onCloseManageMembersModal()">
    </app-manage-broadcast-members-modal>
}

@if (showImageModal) {
    <div class="media-lightbox-backdrop"
         (click)="closeImageModal()">
        <div class="media-lightbox"
             role="dialog"
             aria-modal="true"
             (click)="$event.stopPropagation()">
            <button class="media-lightbox-close"
                    type="button"
                    (click)="closeImageModal()"
                    title="Close">
                <i class="ti ti-x"></i>
            </button>
            @if (selectedMedia) {
                <div class="media-lightbox-body">
                    @if (!isVideoFile(selectedMedia)) {
                        <img [src]="selectedMedia.image_url"
                             [alt]="selectedMedia.label || 'Image'"
                             class="media-lightbox-image">
                    } @else {
                        <video [src]="selectedMedia.image_url"
                               class="media-lightbox-video"
                               controls>
                            Your browser does not support the video tag.
                        </video>
                    }
                </div>
            }
        </div>
    </div>
}
